import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  clearLocalStorage,
  decryptToObject,
  encryptObject,
} from 'src/services/environment';
import { TokenAuth } from 'src/dto/users/users-dto';
import { UsersService } from 'src/services/users/users.service';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';

@Component({
  selector: 'app-okta-callback',
  templateUrl: './sso-okta-callback.component.html',
})
export class SSOOktaCallbackComponent implements OnInit {
  ssoData: any;

  constructor(
    private router: Router,
    private usersService: UsersService,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth
  ) {}

  async ngOnInit() {
    if (!this.oktaAuth.isLoginRedirect()) {
      this.router.navigate(['/login']);
      return;
    }

    try {
      const { tokens } = await this.oktaAuth.token.parseFromUrl();
      if (!tokens?.idToken?.idToken) {
        console.error('Nessun id_token dopo parseFromUrl');
        return;
      }

      this.usersService.loginWithOktaIdToken(tokens.idToken.idToken).subscribe({
        next: (res) => this.handleOktaUser(res),
        error: (err) => {
          console.error('Errore loginWithOktaIdToken');
        },
      });
    } catch (err) {
      console.error('Errore Okta parseFromUrl');
    }
  }

  private handleOktaUser(dataParam: TokenAuth): void {
    sessionStorage.clear();
    clearLocalStorage();
    dataParam.roles = dataParam.roles.map((role) => decryptToObject(role));
    localStorage.setItem('CurrentUser', encryptObject(dataParam));
    this.redirectUser(dataParam);
  }

  private redirectUser(user: TokenAuth) {
    if (user == null) {
      this.router.navigate(['/login']);
    }

    const role = user.roles.find((r) =>
      [
        'SUPER_ADMIN',
        'ADMIN',
        'PIM',
        'DAM',
        'CATALOG',
        'MEDIA_MANAGER',
        'GLRY_VIEW',
      ].includes(r)
    );

    switch (role) {
      case 'SUPER_ADMIN':
      case 'ADMIN':
      case 'PIM':
        this.router.navigate(['/pim']);
        break;

      case 'DAM':
      case 'MEDIA_MANAGER':
        this.router.navigate(['/dam']);
        break;

      case 'CATALOG':
        this.router.navigate(['/catalogues']);
        break;

      case 'GLRY_VIEW':
        this.router.navigate(['/dam/media-library']);
        break;

      default:
        clearLocalStorage();
        this.router.navigate(['/login']);
        break;
    }
  }
}
